import type { FunctionComponent } from "react";
import { FinalizeDMSCostModalPartial } from "../../../../partials/admin/menus/campaign/finalize-dms-cost-modal.admin.partials";

export const FinalizeDMSCostModalAdminScreen: FunctionComponent = () => {
  return <FinalizeDMSCostModalPartial />;
};
